import { handleActions } from "redux-actions";
import {
  FETCH_PROFILE_SUCCESS,
  SET_LOADING,
  SET_SAVING,
  SUBMIT_PROFILE_FAILURE
} from "./userProfileSagas";

export const initialState = {
  user: {},
  isLoading: true,
  isSaving: false,
  errors: null
};

export default handleActions(
  {
    [SET_LOADING]: (state, action) => ({
      ...state,
      isLoading: action.payload
    }),
    [FETCH_PROFILE_SUCCESS]: (state, action) => ({
      ...state,
      user: action.payload,
      errors: null
    }),
    [SET_SAVING]: (state, action) => ({
      ...state,
      isSaving: action.payload
    }),
    [SUBMIT_PROFILE_FAILURE]: (state, action) => ({
      ...state,
      errors: action.payload
    })
  },
  initialState
);
